export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2,'0');
  const month = (date.getMonth() + 1).toString().padStart(2,'0');
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

// helper.js
const months = {
  1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun",
  7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec"
};

export function getMonthName(monthValue) {
  // If monthValue is a comma-separated string like "1,2,3"
  if (typeof monthValue === "string" && monthValue.includes(",")) {
    return monthValue
      .split(",")
      .map(num => months[parseInt(num.trim(), 10)] || num)
      .join(", ");
  }
  
  // Single month case
  return months[parseInt(monthValue, 10)] || monthValue;
}

export function getYearMonthName(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = months[date.getMonth() + 1] || (date.getMonth() + 1);
  const year = date.getFullYear();
  return `${month}-${year}`;
}